module.exports = __webpack_public_path__ + "css/ecube.80d59d1b.css";